/* 进度条页面状态
 */
export const DOING = 'DOING' // 正在
export const COMPLETE = 'COMPLETE' // 完成

/* 后台接口状态
 */
export const WAIT = 'wait' // 等待中
export const PROCESS = 'process' // 处理中
export const END = 'end' // 任务结束
